const rankingItems = [
  { rank: 1, title: '锦绣芳华', category: '古装传奇', score: '9.6', tag: '热播', tagColor: 'text-primary-600 bg-primary-100' },
  { rank: 2, title: '暗夜追击', category: '悬疑刑侦', score: '9.4', tag: '新剧', tagColor: 'text-accent-600 bg-accent-100' },
  { rank: 3, title: '春风十里不如你', category: '都市情感', score: '9.3', tag: '飙升', tagColor: 'text-secondary-600 bg-secondary-100' },
  { rank: 4, title: '大漠孤烟', category: '历史正剧', score: '9.1', tag: '推荐', tagColor: 'text-primary-600 bg-primary-100' },
  { rank: 5, title: '未来之城 2049', category: '科幻巨制', score: '9.0', tag: '新剧', tagColor: 'text-accent-600 bg-accent-100' },
  { rank: 6, title: '舌尖上的江湖', category: '美食剧情', score: '8.9', tag: '', tagColor: '' },
  { rank: 7, title: '深海密码', category: '谍战动作', score: '8.8', tag: '', tagColor: '' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-fire-line text-sm w-4 h-4 flex items-center justify-center"></i>
            实时热度
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热播剧集排行榜</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">基于全网热度、用户讨论与播放数据综合计算的实时追剧风向标，每日更新。</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {rankingItems.map((item) => (
            <div key={item.rank} className="group flex items-center gap-4 bg-background-50 rounded-xl p-4 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
              <div className={`flex-shrink-0 w-10 h-10 rounded-xl flex items-center justify-center font-heading text-lg font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  {item.tag && (
                    <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${item.tagColor}`}>{item.tag}</span>
                  )}
                </div>
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span>{item.category}</span>
                  <span className="text-accent-500 font-semibold flex items-center gap-0.5">
                    <i className="ri-star-fill text-[10px] w-3 h-3 flex items-center justify-center"></i>
                    {item.score}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}